import { render, staticRenderFns } from "./lista-usuarios.vue?vue&type=template&id=2fd62ba0&"
import script from "./lista-usuarios.vue?vue&type=script&lang=js&"
export * from "./lista-usuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports